import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export default makeStyles({
  distribuicaoValores: {
    display: 'flex',
    gap: '8px',
  },
  filtroValorContainer: {
    display: 'flex',
    gap: '8px',
  },

  headerResumo: {
    textAlign: 'center',
  },

});

export const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const HeadContainer = styled.div`
    display: flex;
    align-content: space-between;
    flex: 1;
`;

export const ResumoRootContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    flex: 1;
    margin-left: 16px;
`;

export const ResumoSearchActionContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const ResumoOptionsContainer = styled.div`
    display: flex;
    gap: 8px;
`;

export const ValoresActionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ResumoContainer = styled.div` 
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TabelaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const CardTop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 125px;
  border-radius: 10px;

  background-color: ${props => props.color};

  p {
    margin: 1px 0px 1.5px 0px;
    font-family: Roboto;
    font-size: 11px;
    text-align: left;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    
    color: #ffffff;
  }

  p:first-child {
    align-self: center;
    margin: 0 0 4px;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 600;
  }
`;

export const CardInfo = styled.div`
  display: flex;  
  flex-direction: column;
  width: 80%;
`;
